<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'default',
})
</script>
<template>
    <div v-if="data">
      <div class="content-title" v-if="data.showtitle>0">
          <h2>{{ data.name }}</h2>
          <h4 v-if="data.sub">{{ data.sub }}</h4>
      </div>
     <a-timeline mode="alternate">
        <a-timeline-item  v-for="(item,i) in data.child" :key="i" :color="colors[i]">
          <template #dot v-if="item.icon">
              <img :src="addip(item.icon)" class="round" style="width:40px;height:40px;" />
          </template>
          <div class="content-box">
            <h3 :style="{color:colors[i]}">{{ item.name }}</h3>
            <h4 v-if="item.sub">{{ item.sub }}</h4>
            <h5 v-if="item.contents" v-html="item.contents"></h5>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
</template>
<script setup lang="ts" name="default">
import {defineComponent,defineProps ,ref} from 'vue';
import {addip,colors} from '@/utils/util'
defineProps({
  data:Object
})
</script>
<style>
  .year .ant-timeline{color: inherit;}
  .year .ant-timeline .ant-timeline-item-head{background-color:transparent !important;}
</style>
